import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectDeviceType } from '../../../../selectors/ContextSelector';
import EcoRebatesModalNew from '../../../EcoRebates/EcoRebatesModalNew';
import SlidePanel from '../../../SlidePanel/SlidePanel';
import * as styles from './EcoRebates.css';

const cx = classNames.bind(styles);

const EcoRebates = ({ skuId = '' }) => {
    useSelector((state) => selectDeviceType(state));
    const [showDialog, setShowDialog] = useState(false);

    const handleOnClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(true);
    };

    /* istanbul ignore next */
    const handleOnClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(false);
    };
    /* istanbul ignore next */
    const renderHeaderEcorebateSlider = () => {
        return (
            <div className={`${dt(['flex', 'py-6', 'px-6', 'pb-0', 'justify-between'])}`}>
                <span
                    className={`${dt(['text-black', 'font-semibold', 'font-sans', 'text-xlarge'])}`}
                >
                    Rebates Available
                </span>
                <button
                    onClick={handleOnClose}
                    className={`${dt([
                        'flex',
                        'items-center',
                        'justify-center',
                    ])} rebatesCloseButton`}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M25.051 8.64609C25.5196 8.17746 25.5196 7.41767 25.051 6.94904C24.5823 6.48041 23.8225 6.48041 23.3539 6.94904L16 14.3029L8.64609 6.94904C8.17746 6.48041 7.41766 6.48041 6.94903 6.94904C6.4804 7.41767 6.48041 8.17746 6.94903 8.64609L14.3029 16L6.94904 23.3539C6.48041 23.8225 6.48041 24.5823 6.94904 25.051C7.41766 25.5196 8.17746 25.5196 8.64609 25.051L16 17.6971L23.3539 25.051C23.8225 25.5196 24.5823 25.5196 25.051 25.051C25.5196 24.5823 25.5196 23.8225 25.051 23.3539L17.6971 16L25.051 8.64609Z"
                            fill="#202020"
                        />
                    </svg>
                </button>
            </div>
        );
    };
    return skuId ? (
        <button
            className={dt([
                'cursor-pointer',
                'font-sans',
                'py-1',
                'text-black',
                'text-sm',
                'underline',
            ])}
            data-automation-id={`product-eco-rebate-${skuId}`}
            onClick={handleOnClick}
            type="button"
        >
            Rebates Available
            <SlidePanel
                isOpenPanel={showDialog}
                onClosePanel={handleOnClose}
                panelTitleAlignment="justify"
                showBackIcon={false}
                showHeaderIcon={false}
                panelHeaderRenderer={renderHeaderEcorebateSlider}
                panelWidth={cx('panelWidth')}
            >
                <EcoRebatesModalNew skuId={skuId} />
            </SlidePanel>
        </button>
    ) : null;
};

EcoRebates.propTypes = {
    skuId: string.isRequired,
};

export default EcoRebates;
